export const version = "4.0.6";
export const build = "esm";
//# sourceMappingURL=version.js.map
